export const TEST_CHANGE = "TEST_CHANGE";
export const SET_SHOWN_DAY = "SET_SHOWN_DAY";

////APP
export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
export const SET_TITLE = "SET_TITLE";
export const INITIALISE_STATE = "INITIALISE_STATE";
export const CHANGE_FILTER = "CHANGE_FILTER";
export const SHOWN_TYPE_OFFENE = "OFFENE";
export const SHOWN_TYPE_ERLEDIGTE = "ERLEDIGTE";

////Sync
export const DO_SYNC = "DO_SYNC";
export const STOP_SYNC = "STOP_SYNC";
export const REPORT_PROGRESS = "REPORT_PROGRESS";

/////Settings
export const SET_BENUTZER = "SET_BENUTZER";
export const SET_BENUTZER_NAME = "SET_BENUTZER_NAME"
export const SAVE_SETTINGS = "SAVE_SETTINGS";
export const LAST_VISITED_DATE = "LAST_VISITED_DATE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_PRIVILEGED_USER = "SET_PRIVILEGED_USER";
export const SET_PRIVILEGED_USER_MENU = "SET_PRIVILEGED_USER_MENU";


/////Tasks
export const SELECT_APPOINTMENT_BY_ID = "SELECT_APPOINTMENT_BY_ID";
export const SELECT_PERSON_BY_ID = "SELECT_PERSON_BY_ID";
export const SAVE_TV_DATA = "SAVE_TV_DATA";
export const SAVE_TV_DATA_BOCK = "SAVE_TV_DATA_BOCK";
export const SAVE_TV_PROPERTY_VALUE = "SAVE_TV_PROPERTY_VALUE";
export const SET_TV_PROPERTY_VALUE = "SET_TV_PROPERTY_VALUE";
export const SAVE_PERSONS = "SAVE_PERSONS";
export const DELETE_PERSONS = "DELETE_PERSONS";
export const SELECT_NEXT_PERSON_ID = "SELECT_NEXT_PERSON_ID";
export const SAVE_SIGNATURES = "SAVE_SIGNATURES";
export const FOTO_ADD = "FOTO_ADD";
export const FOTO_REMOVE = "FOTO_REMOVE";
export const SELECT_CURRENT_COMPANY = "SELECT_CURRENT_COMPANY";
export const DRIVERS_LIST = "DRIVERS_LIST";


/////Bocks
export const SELECT_BOCK_BY_ID = "SELECT_BOCK_BY_ID";
export const SET_BOCK_VALUE = "SET_BOCK_VALUE";
export const ADD_BOCK_TO_DB = "ADD_BOCK_TO_DB";
export const DELETE_BOCK_FROM_DB = "DELETE_BOCK_FROM_DB";
